export default {
  phone: '(**) *****-****',
  landLinePhone: '(**) ****-*****',
  cpf: '***.***.***-**',
  number: '***.***.***',
  date: '**/**/****',
}
